import BankTypeEnumDTO from "features/shared/enums/dynamic/BankTypeEnumDTO";
import FormGroup from "features/shared/forms/components/FormGroup";
import {
  BindFieldFunction,
  BindReactSelectFunction,
  ClearFormValuesFunction,
  FormErrors,
  SetValidationErrorFunction,
  SetValidationRuleFunction,
  ValidateFormFieldFunction,
} from "features/shared/forms/hooks/useForm";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import reactSelectStyles from "features/shared/components/reactSelect/reactselectcustom.module.scss";
import {
  setBankAccountValidations,
  validateAccountNumber,
  validatePreAccountNumber,
} from "./bankAccountValidations";
import { UserEnumDTO } from "features/shared/enums/dynamic/UserEnumDTO";

type Props = {
  banks: UserEnumDTO[];
  bindField: BindFieldFunction;
  bindReactSelectField: BindReactSelectFunction;
  setValidationRule: SetValidationRuleFunction;
  validateFormField: ValidateFormFieldFunction;
  setValidationError: SetValidationErrorFunction;
  clearFormValues: ClearFormValuesFunction;
  errors: FormErrors;
  preAccountClassName?: string;
  accountClassName?: string;
  bankClassName?: string;
};

// TODO: doplnit IBAN a pouzit v komponente BankAccountDialog
const BankAccountSubForm = ({
  bindField,
  bindReactSelectField,
  clearFormValues,
  setValidationRule,
  validateFormField,
  setValidationError,
  banks,
  errors,
  preAccountClassName = "col-sm-4 col-lg-3 px-2",
  accountClassName = "col-sm-8 col-lg-5 px-2",
  bankClassName = "col-12 col-lg-4 px-2",
}: Props) => {
  // translations
  const tLabels = useTranslation("payments\\payments").t;

  // side-effects
  useEffect(() => {
    // set default validations
    setBankAccountValidations(setValidationRule);

    return () => {
      // before unmount component remove values and validations
      setBankAccountValidations(setValidationRule, "remove");
      clearFormValues(["preAccountNumber", "accountNumber", "bankCode"]);
    };
  }, []);

  // handlers
  const preAccountNumberBlurHandler = (
    e: React.FocusEvent<HTMLInputElement>
  ) => {
    validatePreAccountNumber(
      e.target.value,
      validateFormField,
      setValidationError
    );
  };

  const accountNumberBlurHandler = (e: React.FocusEvent<HTMLInputElement>) => {
    validateAccountNumber(
      e.target.value,
      validateFormField,
      setValidationError
    );
  };

  // render
  return (
    <div className="row no-gutters mx-n2">
      <div className={preAccountClassName}>
        <FormGroup
          labelText={tLabels("bankAccountDialog.preNumber")}
          validationError={errors["preAccountNumber"]}
        >
          <input
            className="form-control"
            placeholder={tLabels("bankAccountDialog.preAccountNumber")}
            // disabled={internationalAccount}
            onBlur={preAccountNumberBlurHandler}
            {...bindField("preAccountNumber")}
          />
        </FormGroup>
      </div>
      <div className={accountClassName}>
        <FormGroup
          labelText={tLabels("bankAccountDialog.accountNumber")}
          validationError={errors["accountNumber"]}
        >
          <input
            className="form-control"
            placeholder={tLabels("bankAccountDialog.setAccountNumber")}
            // disabled={internationalAccount}
            onBlur={accountNumberBlurHandler}
            {...bindField("accountNumber")}
          />
        </FormGroup>
      </div>
      <div className={bankClassName}>
        <FormGroup
          labelText={tLabels("bankAccountDialog.bank")}
          validationError={errors["bankCode"]}
        >
          <Select
            {...bindReactSelectField<UserEnumDTO>(
              "bankCode",
              "code",
              banks
            )}
            getOptionLabel={(bank) => `${bank.code} - ${bank.name}`}
            captureMenuScroll={false}
            className={reactSelectStyles.customSelect}
            classNamePrefix="customSelect"
            placeholder={tLabels("bankAccountDialog.setBank")}
            noOptionsMessage={() => tLabels("bankAccountDialog.noBanksFound")}
          />
        </FormGroup>
      </div>
    </div>
  );
};

export default BankAccountSubForm;
